import { useScrollReveal } from '@/hooks/useScrollReveal';

const WHATSAPP_URL = 'https://wa.me/918861133745?text=Hi%2C%20I%27m%20interested%20in%20Confident%20Auriga.%20Please%20share%20more%20details.';

export default function CTASection() {
  useScrollReveal('.cta-reveal', 0.1);

  return (
    <section className="py-12 md:py-20 bg-primary relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20drone%20photograph%20of%20premium%20plotted%20land%20development%20at%20golden%20hour%20sunset%20with%20organized%20plot%20boundaries%2C%20wide%20paved%20roads%2C%20green%20vegetation%2C%20warm%20orange%20and%20gold%20sky%20light%2C%20cinematic%20real%20estate%20photography%2C%20high%20altitude%20perspective%2C%20empty%20land%20plots%20ready%20for%20construction%2C%20peaceful%20and%20serene%20atmosphere%2C%20dark%20overlay%20compatible&width=1200&height=438&seq=cta-v2&orientation=landscape"
          alt="Premium plotted development aerial view"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/95 to-primary/90" />
      </div>

      <div className="section-padding relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="cta-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 border border-white/20 rounded-full font-body text-[10px] md:text-xs tracking-[0.2em] uppercase text-white/80">
              <span className="w-1.5 h-1.5 bg-gold rounded-full animate-pulse" />
              Limited Availability
            </span>
          </div>

          <h2 className="cta-reveal scroll-reveal font-display text-2xl md:text-4xl lg:text-5xl xl:text-6xl text-white font-bold mt-4 md:mt-5 leading-tight">
            Secure Your Investment In
            <br />
            <span className="text-gold">Malur&rsquo;s Growth Corridor</span>
          </h2>

          <p className="cta-reveal scroll-reveal font-body text-sm md:text-lg text-white/70 mt-4 md:mt-5 leading-relaxed max-w-xl mx-auto">
            Book your site visit today and explore premium plotted development Bangalore investment opportunities at Confident Auriga Malur.
          </p>

          <div className="cta-reveal scroll-reveal flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mt-7 md:mt-10">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-7 md:px-8 py-3.5 md:py-4 bg-gold text-primary font-body font-semibold text-xs md:text-sm tracking-wider uppercase rounded-full transition-all duration-500 hover:bg-gold-light hover:text-primary hover:scale-[1.02] active:scale-[0.98] whitespace-nowrap hover:shadow-lg hover:shadow-gold/20"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp Enquiry
            </a>
            <a
              href="tel:+918861133745"
              className="inline-flex items-center gap-2 px-7 md:px-8 py-3.5 md:py-4 bg-white/10 backdrop-blur-md border border-white/30 text-white font-body font-semibold text-xs md:text-sm tracking-wider uppercase rounded-full transition-all duration-500 hover:bg-white hover:text-primary hover:scale-[1.02] active:scale-[0.98] whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              Call Now
            </a>
          </div>

          <p className="cta-reveal scroll-reveal font-body text-[10px] md:text-xs text-white/40 mt-5 md:mt-6 tracking-wider">
            Site visits available 7 days a week | Call +91 88611 33745
          </p>
        </div>
      </div>
    </section>
  );
}